var t = require('babel-types');
var parseExpressions = require('../core/parseExpressions');

module.exports = {
  enter: function (node, parent, index) {},
  exit: function (node, parent, index) {
    if (node.expressions) {
      parent[index] = parseExpressions(node);
    } else {
      parent[index] = t.stringLiteral(node.value);
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./packages/cssx-transpiler/src/visitors/CSSXSelector.js
 ** module id = 429
 ** module chunks = 0
 **/